export default "__VITE_ASSET__DWWQytoj__"